/* ==========================================================================
   FreezeCap™ — fc-fit.liquid wiring (extracted from inline script in v6.29)
   --------------------------------------------------------------------------
   Vehicle compatibility selector. Reads year/make/model from form inputs,
   looks up the refrigerant via window.FreezeCapCompat (provided by
   assets/vehicle-compatibility.js), and updates the result panel + the
   matching variant on the CTA.

   Localization: result copy comes from window.FC_FIT_I18N (injected by
   snippets/fc-fit-i18n.liquid from the freezecap.fit_js / fit_note keys),
   with the English strings below as fallbacks. Compat-DB notes are resolved
   by detail.noteId when the i18n config provides a translation, else the
   English detail.note is used.

   Each section root carries `data-fc-fit-section="<section.id>"` so the
   script can scope its DOM lookups when the section is cloned in the
   theme editor (multi-instance safe). The existing per-instance IDs
   (`fit-year-<section.id>`, `fit-result-<section.id>`, etc.) are preserved.
   ========================================================================== */
(function () {
  function cfg() {
    return (typeof window !== 'undefined' && window.FC_FIT_I18N) || {};
  }
  function fill(tmpl, fallback, vars) {
    var s = tmpl || fallback;
    return s
      .replace(/\{vehicle\}/g, vars.vehicle)
      .replace(/\{refrigerant\}/g, vars.refrigerant)
      .replace(/\{note\}/g, vars.note)
      .replace(/\{price\}/g, vars.price);
  }

  function wire(section) {
    var sectionId = section.dataset.fcFitSection;
    if (!sectionId) return;

    var yearInput  = document.getElementById('fit-year-'  + sectionId);
    var makeSelect = document.getElementById('fit-make-'  + sectionId);
    var modelInput = document.getElementById('fit-model-' + sectionId);
    var resultEl   = document.getElementById('fit-result-' + sectionId);
    var titleEl    = document.getElementById('fit-result-title-' + sectionId);
    var bodyEl     = document.getElementById('fit-result-body-'  + sectionId);
    var ctaEl      = document.getElementById('fit-result-cta-'   + sectionId);
    var ctaLabelEl = document.getElementById('fit-result-cta-label-' + sectionId);

    if (!yearInput || !makeSelect || !resultEl) return;

    var productUrl   = resultEl.getAttribute('data-product-url') || '/products/freezecap';
    var variantR134a = resultEl.getAttribute('data-variant-r134a');
    var variantR1234 = resultEl.getAttribute('data-variant-r1234yf');

    /* Populate make options from the compatibility db (idempotent: skip if
       options already exist beyond the placeholder). */
    if (window.FreezeCapCompat && window.FreezeCapCompat.makes && makeSelect.options.length <= 1) {
      window.FreezeCapCompat.makes.forEach(function (make) {
        var opt = document.createElement('option');
        opt.value = make;
        opt.textContent = make;
        makeSelect.appendChild(opt);
      });
    }

    function updateResult() {
      var year  = yearInput.value.trim();
      var make  = makeSelect.value;
      var model = modelInput ? modelInput.value.trim() : '';

      if (!year || !make || !window.FreezeCapCompat) {
        showPlaceholder();
        return;
      }

      var detail = window.FreezeCapCompat.getRefrigerantDetailed(year, make, model);

      /* Known physical-port incompatibility — surface it and don't offer the
         buy CTA for a product that won't physically fit. */
      if (detail && detail.compatible === false) {
        showIncompatible(detail, year, make, model);
        return;
      }

      if (!detail || !detail.refrigerant) {
        showPlaceholder();
        return;
      }

      var dict = cfg();
      var vehicleLabel = year + ' ' + make + (model ? ' ' + model : '');
      var refrigerant  = detail.refrigerant;
      var confidence   = detail.confidence;
      /* Prefer a localized note (by stable noteId) when available, else the
         English note carried on the detail object. */
      var note = (dict.notes && detail.noteId && dict.notes[detail.noteId]) || detail.note;
      var vars = { vehicle: vehicleLabel, refrigerant: refrigerant, note: note, price: (dict.price || '') };
      var bodyText, titleText;

      if (confidence === 'verify') {
        titleText = fill(dict.verifyTitle, 'Likely {refrigerant}. Verify before ordering.', vars);
        bodyText  = fill(dict.verifyBody, 'Your {vehicle} falls in the 2013–2020 manufacturer transition window. {note}', vars);
      } else if (confidence === 'medium') {
        titleText = fill(dict.likely, 'Your {vehicle} likely uses {refrigerant}.', vars);
        bodyText  = note + (dict.mediumSuffix || ' Add the exact model for a more confident match.');
      } else {
        titleText = fill(dict.uses, 'Your {vehicle} uses {refrigerant}.', vars);
        bodyText  = note;
      }

      titleEl.textContent = titleText;
      bodyEl.innerHTML    = bodyText;

      /* Wire the CTA to the matching variant */
      if (ctaEl && ctaLabelEl) {
        var variantId = refrigerant === 'R-1234yf' ? variantR1234 : variantR134a;
        var href = productUrl + (variantId ? '?variant=' + encodeURIComponent(variantId) : '');
        ctaEl.setAttribute('href', href);
        ctaEl.removeAttribute('hidden');
        ctaLabelEl.textContent = fill(dict.cta, 'Buy FreezeCap™ {refrigerant} for {price} →', vars);
      }

      resultEl.classList.remove('placeholder');
      resultEl.classList.remove('verify');
      resultEl.classList.remove('incompatible');
      resultEl.classList.add('match');
      if (confidence === 'verify') resultEl.classList.add('verify');
    }

    function showIncompatible(detail, year, make, model) {
      var dict = cfg();
      var vehicleLabel = year + ' ' + make + (model ? ' ' + model : '');
      /* Prefer a localized note (by stable noteId) when available, else the
         English note carried on the detail object. */
      var note = (dict.notes && detail.noteId && dict.notes[detail.noteId]) || detail.note;
      var vars = { vehicle: vehicleLabel, refrigerant: '', note: note };

      titleEl.textContent = fill(dict.incompatibleTitle, 'FreezeCap™ may not fit your {vehicle}.', vars);
      bodyEl.innerHTML    = note;

      /* No buy CTA — the cap won't physically seat on this port. */
      if (ctaEl) ctaEl.setAttribute('hidden', '');

      resultEl.classList.remove('placeholder');
      resultEl.classList.remove('verify');
      resultEl.classList.remove('match');
      resultEl.classList.add('incompatible');
    }

    function showPlaceholder() {
      titleEl.textContent = cfg().placeholder || 'Fill in your vehicle to check refrigerant type and recommended FreezeCap™ model.';
      bodyEl.innerHTML    = '';
      if (ctaEl) ctaEl.setAttribute('hidden', '');

      resultEl.classList.remove('match');
      resultEl.classList.remove('verify');
      resultEl.classList.remove('incompatible');
      resultEl.classList.add('placeholder');
    }

    yearInput.addEventListener('input', updateResult);
    makeSelect.addEventListener('change', updateResult);
    if (modelInput) modelInput.addEventListener('input', updateResult);
  }

  function init() {
    document.querySelectorAll('[data-fc-fit-section]').forEach(wire);
  }

  /* vehicle-compatibility.js is also deferred — wait for DOM + the
     compat database to be wired up. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
